/**
 * Created by emanuele on 31/01/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {copiaTestoNegliAppunti} from '../Helpers';

class ShowOptionalLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClick(e, value){
        // Copia value negli appunti
        copiaTestoNegliAppunti(value)
    }

    render(){
        let value = this.props.value;
        let icon = this.props.icon;
        let extraClassName = this.props.extraClassName;
        let title = this.props.title;
        title += ' - Click per copiare sugli appunti'

        if (value)
        {
            if (icon !== undefined && icon !== null && icon !== '')
            {
                return <div title={title} className={"ui label pointer " + extraClassName} onClick={(e) => this.onClick(e, value)}><i className={icon + " icon"}></i> {value}</div>
            }
            else
            {
                return <div title={title} className={"ui label pointer " + extraClassName} onClick={(e) => this.onClick(e, value)}>{value}</div>
            }
        }
        else{
            return null
        }
    }
}

ShowOptionalLabel.PropTypes = {
    icon: PropTypes.string,
    value: PropTypes.string,
    extraClassName: PropTypes.string,
    title: PropTypes.string,
}

ShowOptionalLabel.defaultProps = {
    title: '',
};
export default ShowOptionalLabel;


/** WEBPACK FOOTER **
 ** ./src/components/ShowOptionalLabel.jsx
 **/